// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"00d78e84","453":"672c151b"}[chunkId] + ".chunk.js";
};